import multipleImage, { multipleImageVariants, MultipleImageVariantsType } from './multiple-image';
import type { CustomTheme } from '../../../types/custom-theme';
import type { Product } from '../../../types/product';

const hero = {
  multipleImage,
};

export const heroVariants = {
  multipleImage: multipleImageVariants,
};

export type HeroComponentsType = 'multipleImage';

export interface HeroType {
  /** The Hero subcomponent types. */
  SubComponents: {
    [K in HeroComponentsType]: Product.VariantKeyModes<K extends 'multipleImage' ? MultipleImageVariantsType : never>;
  };
  /** The Multiple Image variants type. */
  MultipleImage: CustomTheme.VariantKeys<MultipleImageVariantsType>;
}

export default hero;
